import LocalDataManager from '../managers/LocalDataManager';
import WebApiService from '../services/WebApiService';

export default class BlastService extends WebApiService {

    constructor(indexedDbManager) {
        super();

        if (indexedDbManager) {
            this.indexedDbManager = indexedDbManager;
        }
        else {
            this.indexedDbManager = new LocalDataManager();
        }

        this.inboundBlastData = this.inboundBlastData.bind(this);
        this.blastData = this.blastData.bind(this);

        this.track = this.track.bind(this);

        this.checkTimeout = 1000 * 60 * 5; //mins

        this.offlineTimeSec = 0;

        this.checkInterval = -1;

        this.blastSubscriptionData = null;

    }

    blastData(data, successCallback, errorCallback) {
        //this.post('/api/Broadcast/blastRaw', data, successCallback, errorCallback);
        let dataArray = [data];
        this.post('/api/Broadcast/Blast', dataArray, successCallback, errorCallback);
    }

    trackData(data) {

        this.post('/api/Broadcast/track', data);
    }

    async inboundBlastData(rawData) {
        let self = this;
        let blastData = JSON.parse(rawData);
        self.indexedDbManager.saveBlastLocationDataFrom(blastData.storeId, blastData.locationData, () => {
            self.indexedDbManager.saveBlastEmployeeDataFrom(blastData.storeId, blastData.employeeData, () => {
                self.indexedDbManager.saveBlastEmployeeOverwriteDataFrom(blastData.employeeOverwriteData, () => {
                    if (self.blastCallback) {
                        self.blastCallback(blastData.lastBlastDate, blastData.storeId);
                    }
                });
            });
        });
    }

    loadBlast() {
        let self = this;
        if (self.checkInterval == -1) {
            self.checkInterval = setInterval(() => {
                self.refreshBlastData(this.inboundBlastData)
            }, self.checkTimeout);
        }
    }

    subscribe(blastSubscription, blastCallback, callback) {
        let self = this;
        this.blastCallback = blastCallback;
        //blastSubscription.userId, blastSubscription.companyId, blastSubscription.storeIds, blastSubscription.filterDate
        self.blastSubscriptionData = blastSubscription;
        this.loadBlast();
        if (callback) {
            callback(blastSubscription.storeIds);
        }
    }

    //storeIds = null, unsubscribes All stores
    unsubscribeAll(callback, errorCallback) {
        clearInterval();
        this.checkInterval = -1;
        if (callback) {
            callback();
        }
    }

    refreshBlastData(callback) {
        if (this.blastSubscriptionData != null) {

            var currentDate = new Date();
            if(document.getElementById("metrics-inline-date-picker-portait") != undefined && 
              document.getElementById("metrics-inline-date-picker-portait") != null)
            {
                var filterDate = new Date(document.getElementById("metrics-inline-date-picker-portait").value);

                if (filterDate.getYear() === currentDate.getYear() && filterDate.getMonth() === currentDate.getMonth() && filterDate.getDay() === currentDate.getDay()) {
                    var storeIds = this.blastSubscriptionData.storeIds;
                        let jsonDataString = JSON.stringify(this.blastSubscriptionData);
                        let jsondata = JSON.parse(jsonDataString);
                        this.blastData(jsondata, callback, ()=>{
                            alert("Something went wrong while loading data.");
                        });
                }
            }
        }
    }

    //types: phone,chat,inspectDate,inspectMetric,inspectPeeps,inspectStore,compareMode,changeMode, sort
    track(companyId, storeId, locationOrEmployeeName, type, details) {
        if (locationOrEmployeeName == undefined || details === undefined)
            return;

        switch (type) {
            case 'phone':
                details = "Calling: " + details;
                break;
            case 'chat':
                details = "Texting: " + details;
                break;
            case 'inspectDate':
                details = "Inspect Date: " + details;
                break;
            case 'inspectMetric':
                details = "Inspect Metric: " + details;
                break;
            case 'inspectPeeps':
                details = "Inspect Peeps: " + details;
                break;
            case 'inspectStore':
                details = "Inspect Store: " + details;
                break;
            case 'compareMode':
                details = "Change comparison mode: " + details;
                break;
            case 'changeMode':
                details = "Change Mode: " + details;
                break;
            case 'sort':
                details = "Sort by:" + details;
                break;
            default:
                break;
        }

        this.indexedDbManager.getAuthInfo().then((auth) => {
            let trackData = {
                storeId: storeId,
                companyId: companyId,
                report: "Blast - " + locationOrEmployeeName,
                details: details,
                userName: auth.userName
            };
            this.trackData(trackData);
        });
    }


    unBindBlast() {
        let self = this;
        delete this.blastCallback;
    }
}